import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let action_type = useDataValue({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'type',
  })
  let action_id = useDataValue({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'id',
  })
  let expand = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
  })
  return useMemo(() => {
    // find if state present in parent
    if (action_id in expand) {
      return expand[action_id]
    }
    return { ...data, is_expanded: !action_type ? true : false }
  }, [])
}
